import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import UserPhotoWithUpload from 'components/UserPhotoWithUpload'
import UserPhotoWithUploadAndCropper from 'components/UserPhotoWithUploadAndCropper'

storiesOf('UserPhoto', module)
  .add('UserPhotoWithUpload', () => (
    <UserPhotoWithUpload
      showUploadIcon
      photoUrl="http://i.pravatar.cc/128"
      onPhotoUpload={action('onPhotoUpload')}
    />
  ))
  .add('UserPhotoWithUploadAndCropper', () => (
    <UserPhotoWithUploadAndCropper
      showUploadIcon
      photoUrl="http://i.pravatar.cc/128"
      onPhotoAccept={action('onPhotoAccept')}
    />
  ))
